import React from 'react';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';

import ListHeader from 'components/List/Header';
import ListRow from 'components/List/Row';
import Input from 'components/Input';

const WxrParamListContainer = styled.div`
  .wxrParamListExplainText {
    margin-bottom: 20px;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 14px;
    line-height: 24px;
  }

  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
  }
  .rightComponentsContainer > :not(:last-child) {
    margin-right: 10px;
  }

  .tasterContainer {
    color: ${(props) => props.theme.colors.dark};
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    width: calc(60% - 31px);
    padding-left: 31px;
  }

  .ponderationContainer {
    width: 40%;
    justify-content: center;
    align-items: center;
  }

  .totalContainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${(props) => props.theme.colors.dark};
    color: white;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    height: 40px;
    font-size: 12px;
  }

  .totalLabel {
    margin-left: 6%;
  }

  .totalValue {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    margin-left: auto;
    margin-right: 17%;
  }
`;

const renderRows = (data, handlePonderation, admin) =>
  data.map((param, index) => (
    <ListRow
      dark={index % 2 === 0}
      disabled={!param.ponderation}
      key={param.id}
    >
      <div className="indexContainer">
        <p>{param.position}</p>
      </div>
      <div className="tasterContainer">
        <p>{param.journal_name}</p>
      </div>
      <div className="ponderationContainer">
        <Input
          height="30px"
          disabled={!admin}
          styles={`width:60%; input {text-align:center; font-size:14px;color:rgba(39,53,68,0.5); padding-left:0px !important}`}
          value={param.ponderation}
          onChange={(value) => handlePonderation(param.journal_name, value)}
        />
      </div>
    </ListRow>
  ));

const WxrParamList = ({ data, handlePonderation, admin }) => (
  <WxrParamListContainer>
    <p className="wxrParamListExplainText">{I18n.t('notes.wxr.explainText')}</p>
    <div className="wxrParamListContainer">
      <ListHeader
        columns={[
          {
            name: I18n.t('notes.wxr.yxr.journalist'),
            padding: '11px',
            length: 'calc(60% - 20px)'
          },
          {
            name: I18n.t('notes.wxr.yxr.weighting'),
            length: 'calc(40% - 11px)',
            padding: '11px'
          }
        ]}
      />

      {renderRows(data, handlePonderation, admin)}

      <div className="totalContainer">
        <p className="totalLabel">{I18n.t('notes.wxr.yxr.total')}</p>
        <p className="totalValue">{data && data.length}</p>
      </div>
    </div>
  </WxrParamListContainer>
);

export default WxrParamList;
